import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-useractivation-dialog',
  templateUrl: './useractivation-dialog.component.html',
  styleUrls: ['./useractivation-dialog.component.scss']
})
export class UserActivationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UserActivationDialogComponent>,
    private router: Router,) { }

  ngOnInit(): void {
  }
  
  ClickYes(response) {
    this.dialogRef.close(response);
  }

  ClickNo(response){
    this.dialogRef.close(response);
    sessionStorage.removeItem("userToken");
    sessionStorage.removeItem("permissions");
    sessionStorage.removeItem("databaseId");
    sessionStorage.removeItem("organizationID");
    sessionStorage.removeItem("profileImagePath");
    sessionStorage.removeItem("moduleName");
    sessionStorage.removeItem("localFiltersContact");
    sessionStorage.removeItem("localFiltersCompany");
    sessionStorage.removeItem("localFilters");
    sessionStorage.removeItem("folderAccess");
    sessionStorage.removeItem("transactionID");
    sessionStorage.removeItem("HeaderModuleName");
    sessionStorage.removeItem("DashboardRefresh");
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.removeItem("FolderOpenId");    
    sessionStorage.removeItem("type");
    sessionStorage.clear();
     this.router.navigate(['/auth/login']);

   // this.commonService.logoutUser();
  }

  
}
